module.exports = __webpack_public_path__ + "img/c1294d3.jpg";